$(document).ready(function () {

  function fixShopFollowButtonContrast() {
    var host = document.querySelector('shop-follow-button');
    if (!host) return;

    function apply(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.text-white, .cursor-pointer, button').forEach(function (el) {
        try {
          el.style.setProperty('color', '#111827', 'important');
        } catch (e) {}
      });
    }

    // Light DOM
    apply(host);
    // Shadow DOM (if used)
    try {
      if (host.shadowRoot) apply(host.shadowRoot);
    } catch (e) {}

    // Re-apply if the component re-renders.
    try {
      var target = host.shadowRoot || host;
      if (target.__a11yObserverInstalled) return;
      target.__a11yObserverInstalled = true;
      var obs = new MutationObserver(function () {
        apply(target);
      });
      obs.observe(target, { subtree: true, childList: true, attributes: true });
    } catch (e) {}
  }

  function fixSlickAriaTabindex($slider) {
    if (!$slider || !$slider.length) return;
    // Slick adds aria-hidden to slides; ensure hidden slides are not focusable.
    $slider.find('[aria-hidden=\"true\"][tabindex=\"0\"]').attr('tabindex', '-1');
    $slider.find('[aria-hidden=\"false\"][tabindex=\"-1\"]').removeAttr('tabindex');
  }

  function installSlickA11yObserver($slider) {
    if (!$slider || !$slider.length) return;
    var el = $slider.get(0);
    if (!el || el.__slickA11yObserverInstalled) return;
    el.__slickA11yObserverInstalled = true;

    // Run once after current call stack (Slick may set attrs after init fires).
    setTimeout(function () {
      fixSlickAriaTabindex($slider);
    }, 0);

    try {
      var obs = new MutationObserver(function () {
        fixSlickAriaTabindex($slider);
      });
      obs.observe(el, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden', 'tabindex'] });
    } catch (e) {}
  }

  // A11y: harden blog/RTE content against missing alt/text.
  // Blog posts often contain hand-authored HTML; this makes audits resilient even when
  // images/links are missing `alt` / discernible text.
  function ensureContentMediaA11y() {
    function humanizeSlug(slug) {
      if (!slug) return '';
      return slug
        .replace(/[-_]+/g, ' ')
        .replace(/\b\w/g, function (m) { return m.toUpperCase(); })
        .trim();
    }

    function labelFromHref(href, opensInNewTab) {
      if (!href) return '';
      try {
        var u = new URL(href, window.location.origin);
        var host = (u.hostname || '').replace(/^www\./, '');
        var path = (u.pathname || '').replace(/\/+$/, '');
        var parts = path.split('/').filter(Boolean);
        var suffix = opensInNewTab ? ' (opens in new tab)' : '';

        // External links: label by domain (and best-effort slug).
        if (u.hostname && u.hostname !== window.location.hostname) {
          if (parts.length) return 'Visit ' + host + ': ' + humanizeSlug(parts[parts.length - 1]) + suffix;
          return 'Visit ' + host + suffix;
        }

        if (!parts.length) return '';
        var last = parts[parts.length - 1];
        if (parts[0] === 'products' && last) return 'View product: ' + humanizeSlug(last) + suffix;
        if (parts[0] === 'collections' && last) return 'View collection: ' + humanizeSlug(last) + suffix;
        if (parts[0] === 'blogs' && last) return 'View article: ' + humanizeSlug(last) + suffix;
        if (last) return 'Open link: ' + humanizeSlug(last) + suffix;
        return '';
      } catch (e) {
        return '';
      }
    }

    function applyTo(container) {
      if (!container || !container.querySelectorAll) return;

      // 1) Ensure every image has an `alt` attribute (empty is allowed for decorative).
      container.querySelectorAll('img:not([alt])').forEach(function (img) {
        try {
          img.setAttribute('alt', '');
        } catch (e) {}
      });

      // 1b) Ensure embedded frames have a title (fixes Lighthouse frame-title).
      container.querySelectorAll('iframe:not([title]), frame:not([title])').forEach(function (frame) {
        try {
          var src = frame.getAttribute('src') || '';
          var title = 'Embedded content';
          try {
            var u = new URL(src, window.location.origin);
            var host = (u.hostname || '').replace(/^www\./, '');
            if (host.includes('spotify.com')) title = 'Spotify embed';
            else if (host.includes('player.vimeo.com') || host.includes('vimeo.com')) title = 'Vimeo video';
            else if (host.includes('youtube.com') || host.includes('youtu.be')) title = 'YouTube video';
            else if (host) title = 'Embedded content from ' + host;
          } catch (e) {}
          frame.setAttribute('title', title);
        } catch (e) {}
      });

      // 2) Ensure image-only links have a label (fixes "links have discernible text").
      container.querySelectorAll('a[href]').forEach(function (a) {
        try {
          // Remove truly empty anchors created by editors.
          var hasChildren = a.children && a.children.length > 0;
          var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
          if (!hasChildren && !text) {
            a.remove();
            return;
          }

          // If link already has a label, skip.
          if (a.getAttribute('aria-label') || a.getAttribute('aria-labelledby')) return;

          // If it has readable text, it's fine.
          if (text) return;

          // If it's just images (common in articles), label from href.
          var label = labelFromHref(a.getAttribute('href'), a.getAttribute('target') === '_blank');
          if (label) a.setAttribute('aria-label', label);
        } catch (e) {}
      });
    }

    function apply(root) {
      if (!root || !root.querySelectorAll) return;
      // Focus on content containers, plus a few known custom areas (hero bgvideo, mobile about image).
      root.querySelectorAll('.article-template__content, .rte, .shopify-policy__body, .bgvideo, .mobaboutimg').forEach(function (el) {
        applyTo(el);
      });
    }

    apply(document);

    // Re-apply if a page builder/app mutates the article content.
    try {
      if (document.__imgAltA11yObserverInstalled) return;
      document.__imgAltA11yObserverInstalled = true;
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var t = mutations[i].target;
          if (t && t.nodeType === 1) apply(t);
        }
      });
      obs.observe(document.body, { subtree: true, childList: true });
    } catch (e) {}
  }

  fixShopFollowButtonContrast();
  ensureContentMediaA11y();

var lastShownDate = localStorage.getItem("popup_last_shown");
  var currentDate = new Date().toDateString();

  if (lastShownDate !== currentDate) {
    // Show the popup when the user scrolls down the page
    var popupShown = false;

    $(window).scroll(function () {
      // Set the scroll threshold (e.g., 50% of the page height)
      var scrollThreshold = $(document).height() * 0.1;
      // Check if the user has scrolled past the threshold, the popup hasn't been shown yet, and it hasn't been shown today
      if ($(window).scrollTop() > scrollThreshold && !popupShown) {
        // Show the popup
        $("#popup-container").show();
        $("body").addClass("popup-overlay");
        // Set the flag to indicate that the popup has been shown
        popupShown = true;
        // Store the current date in local storage
        localStorage.setItem("popup_last_shown", currentDate);
      }
    });
  }

  // Handle button click
  $("#close-popup").on("click", function () {
    // Hide the popup
    $("#popup-container").hide();
    $("body").removeClass("popup-overlay");
    // Set the cookie to remember that the popup was hidden
    setCookie("popup_hidden", "true", 1); // 1 day
  });

  // Function to set a cookie with days instead of seconds
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  // Function to get a cookie by name
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /// culterra collection product slider
  $(".featured_collection_slick_slider")
    .on("init reInit afterChange setPosition", function () {
      var $s = $(this);
      installSlickA11yObserver($s);
      fixSlickAriaTabindex($s);
    })
    .slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
    });
  /// culterra collection list slider
  $(".for-mobile-slider-")
    .on("init reInit afterChange setPosition", function () {
      var $s = $(this);
      installSlickA11yObserver($s);
      fixSlickAriaTabindex($s);
    })
    .slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
    });
  // resizing the window for collection list
  if ($(".for-mobile-slider").length > 0) {
    $(window).resize(function () {
      $(".for-mobile-slider")[0].slick.refresh();
    });
  }

  // resizing the window collection list
  if ($(".featured_collection_slick_slider").length > 0) {
    $(window).resize(function () {
      $(".featured_collection_slick_slider")[0].slick.refresh();
    });
  }

  var interval = setInterval(function () {
    var slider = $(".related-product-slider");

    if (slider.length) {
      console.log(slider.length);
      // Element found, initialize Slick and clear the interval
      $(".related-product-slider").slick({
        dots: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        accessibility: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
      // Ensure aria-hidden slides aren't focusable
      fixSlickAriaTabindex($(".related-product-slider"));

      clearInterval(interval);
    }
  }, 2000);

  // document ready function closed
});

$(".js-load-more").on("click", function () {
  var $this = $(this),
    totalPages = parseInt($("[data-total-pages]").val()),
    currentPage = parseInt($("[data-current-page]").val());
  $this.attr("disabled", true);
  $this.find("[loader]").removeClass("hide");
  currentPage = currentPage + 1;
  var nextUrl = $("[data-next-url]")
    .val()
    .replace(/page=[0-9]+/, "page=" + currentPage);
  $("[data-current-page]").val(currentPage);
  $.ajax({
    url: nextUrl,
    type: "GET",
    dataType: "html",
    success: function (responseHTML) {
      $(".product-grid").append($(responseHTML).find(".product-grid").html());
    },
    complete: function () {
      if (currentPage <= totalPages) {
        $this.attr("disabled", false);
        $this.find("[load-more-text]").removeClass("hide");
        $this.find("[loader]").addClass("hide");
      }
    },
  });
});

$(function () {
  $(".product__modal-opener").click(function () {
    $(".product-media-modal").addClass("open__modal_cus");
    $(".product-media-modal").removeAttr("open");
  });
  $(".product-media-modal__toggle").click(function () {
    $(".product-media-modal").removeClass("open__modal_cus");
  });
});

$(document).ready(function () {
  $(".product-media-modal__content")
    .on("init reInit afterChange", function () {
      fixSlickAriaTabindex($(this));
    })
    .slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      '<div class="left-arrows"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="128.000000pt" height="128.000000pt" viewBox="0 0 128.000000 128.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M602 837 c-131 -131 -172 -178 -172 -197 0 -37 334 -370 371 -370 32 0 49 17 49 49 0 20 -35 61 -147 173 l-148 148 148 148 c95 95 147 155 147 168 0 25 -30 54 -56 54 -12 0 -87 -68 -192 -173z"/></g></svg></div>',
    nextArrow:
      '<div class="right-arrows"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="128.000000pt" height="128.000000pt" viewBox="0 0 128.000000 128.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M408 984 c-8 -18 -9 -31 -2 -42 6 -9 82 -79 170 -155 87 -75 159 -142 159 -147 0 -5 -72 -70 -160 -145 -88 -75 -164 -148 -170 -161 -13 -33 4 -58 41 -62 25 -3 57 20 219 158 105 89 196 169 203 178 30 39 17 55 -188 231 -163 139 -206 171 -231 171 -22 0 -32 -6 -41 -26z"/></g></svg></div>',
    });

  // Bind keyboard events
  $(document).on("keydown", function (e) {
    if ($(".product-media-modal__content").hasClass("slick-initialized")) {
      if (e.keyCode === 37) {
        // Left arrow key
        $(".product-media-modal__content").slick("slickPrev");
      } else if (e.keyCode === 39) {
        // Right arrow key
        $(".product-media-modal__content").slick("slickNext");
      }
    }
  });
});

// Check if the browser is Safari on iOS or macOS
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

// Check if the user agent contains "Mac OS X"
var isMacOS = navigator.userAgent.indexOf("Mac OS X") !== -1;

if (isSafari && (isMacOS || /(iPad|iPhone|iPod)/g.test(navigator.userAgent))) {
  // Add a class to the elements you want to style differently
  var elements = document.querySelectorAll(".close-icon");
  elements.forEach(function (element) {
    element.classList.add("safari-styles");
  });
}

document.addEventListener('DOMContentLoaded', function () {
    const slider = document.getElementById('GalleryThumbnails-template--17185656799472__main');
    const prevButton = slider.querySelector('.slider-button--prev');
    const nextButton = slider.querySelector('.slider-button--next');

    // Add event listeners for keyboard navigation
    document.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        // Left arrow key pressed, simulate click on the previous button
        prevButton.click();
      } else if (event.key === 'ArrowRight') {
        // Right arrow key pressed, simulate click on the next button
        nextButton.click();
      }
    });
  });

$(document).ready(function () {
    showPopupIfUrlContainsParam();
    
    // Add event listener to close button
    $('#successclose').click(function() {
        $('#successPopupwrap').hide(); // Hide the popup
    });
});

function urlContainsParam(paramName) {
    return window.location.href.indexOf(paramName) !== -1;
}

function showPopupIfUrlContainsParam() {
    if (urlContainsParam('?customer_posted=true')) {
        document.getElementById('successPopupwrap').style.display = 'block';
    }
  $(document).on("click", function(e) {
    if ($(e.target).is("#col_dropdown_ .outer_navigation_custom_filter") === false) {
      $("#col_dropdown_").removeAttr("open");
    }
  });
}

(function () {
  function isYouTubeEmbedSrc(src) {
    if (!src) return false;
    return src.indexOf('youtube.com/embed/') !== -1 || src.indexOf('youtube-nocookie.com/embed/') !== -1;
  }

  function ensureYouTubeAutoplaySrc(src, opts) {
    try {
      opts = opts || {};
      var mute = typeof opts.mute === 'boolean' ? opts.mute : true;
      var url = new URL(src, window.location.href);
      // Autoplay on open (mute improves autoplay reliability across browsers).
      url.searchParams.set('autoplay', '1');
      url.searchParams.set('mute', mute ? '1' : '0');
      url.searchParams.set('playsinline', '1');

      // Keep branding/related videos tidy unless explicitly overridden.
      if (!url.searchParams.has('rel')) url.searchParams.set('rel', '0');
      if (!url.searchParams.has('modestbranding')) url.searchParams.set('modestbranding', '1');
      if (!url.searchParams.has('controls')) url.searchParams.set('controls', '0');

      return url.toString();
    } catch (e) {
      var joiner = src.indexOf('?') === -1 ? '?' : '&';
      var muteFallback = opts && typeof opts.mute === 'boolean' ? (opts.mute ? '1' : '0') : '1';
      return src + joiner + 'autoplay=1&mute=' + muteFallback + '&playsinline=1';
    }
  }

  function autoplayYouTubeInModal(modal, opts) {
    try {
      if (!modal) return;
      var iframes = modal.querySelectorAll('iframe');
      if (!iframes || !iframes.length) return;

      for (var i = 0; i < iframes.length; i++) {
        var iframe = iframes[i];
        var src = iframe.getAttribute('src') || '';
        if (!isYouTubeEmbedSrc(src)) continue;

        if (!iframe.dataset.initialSrc) {
          iframe.dataset.initialSrc = src;
        }

        iframe.setAttribute('src', ensureYouTubeAutoplaySrc(src, opts));
      }
    } catch (e) {}
  }

  function stopYouTubeInModal(modal) {
    try {
      if (!modal) return;
      var iframes = modal.querySelectorAll('iframe');
      if (!iframes || !iframes.length) return;

      for (var i = 0; i < iframes.length; i++) {
        var iframe = iframes[i];
        var src = iframe.getAttribute('src') || '';
        if (!isYouTubeEmbedSrc(src)) continue;

        // Restoring the original src reliably stops playback.
        if (iframe.dataset.initialSrc) {
          iframe.setAttribute('src', iframe.dataset.initialSrc);
        }
      }
    } catch (e) {}
  }

  function playHtml5VideosInModal(modal, opts) {
    try {
      if (!modal) return;
      opts = opts || {};
      var preferSound = typeof opts.preferSound === 'boolean' ? opts.preferSound : true;
      var videos = modal.querySelectorAll('video');
      if (!videos || !videos.length) return;

      for (var i = 0; i < videos.length; i++) {
        var video = videos[i];
        if (!video) continue;

        // Mobile-friendly playback.
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');

        // Remember initial mute state.
        if (!video.dataset.initialMuted) {
          video.dataset.initialMuted = video.muted ? '1' : '0';
        }

        if (preferSound) video.muted = false;

        var playPromise = video.play && video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          (function (currentVideo) {
            playPromise.catch(function () {
              try {
                // Autoplay is often blocked unless muted.
                currentVideo.muted = true;
                if (currentVideo.play) currentVideo.play();
              } catch (e) {}
            });
          })(video);
        }
      }
    } catch (e) {}
  }

  function stopHtml5VideosInModal(modal) {
    try {
      if (!modal) return;
      var videos = modal.querySelectorAll('video');
      if (!videos || !videos.length) return;

      for (var i = 0; i < videos.length; i++) {
        var video = videos[i];
        if (!video) continue;

        if (video.pause) video.pause();
        try {
          video.currentTime = 0;
        } catch (e) {}

        if (video.dataset && Object.prototype.hasOwnProperty.call(video.dataset, 'initialMuted')) {
          video.muted = video.dataset.initialMuted === '1';
          delete video.dataset.initialMuted;
        }
      }
    } catch (e) {}
  }

  function handleModalMaybeChanged(modal) {
    if (!modal) return;
    // Theme modal system uses data-open="true|false".
    var isOpen = modal.dataset && modal.dataset.open === 'true';
    if (isOpen) {
      autoplayYouTubeInModal(modal);
      playHtml5VideosInModal(modal, { preferSound: true });
    } else {
      stopYouTubeInModal(modal);
      stopHtml5VideosInModal(modal);
    }
  }

  function getStickyHeaderEls() {
    // Dawn-style header wrapper (sticky class applied here).
    var els = document.querySelectorAll('.section-header.shopify-section-group-header-group');
    if (els && els.length) return els;

    // Fallbacks for other theme variants / markup.
    els = document.querySelectorAll('.shopify-section-group-header-group, sticky-header, header.header, .header-wrapper');
    return els || [];
  }

  function setStickyHeaderHidden(shouldHide) {
    try {
      var els = getStickyHeaderEls();
      if (!els || !els.length) return;

      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (!el || !el.style) continue;

        if (shouldHide) {
          if (!el.dataset.modalPrevDisplay) {
            // Store the original inline display (usually empty string).
            el.dataset.modalPrevDisplay = el.style.display || '';
          }
          el.style.display = 'none';
        } else {
          if (el.dataset && Object.prototype.hasOwnProperty.call(el.dataset, 'modalPrevDisplay')) {
            el.style.display = el.dataset.modalPrevDisplay;
            delete el.dataset.modalPrevDisplay;
          } else {
            el.style.display = '';
          }
        }
      }
    } catch (e) {}
  }

  function isAnyThemeModalOpen() {
    return !!document.querySelector('.modal[data-open="true"]');
  }

  function initYouTubeModalAutoplay() {
    try {
      var modals = document.querySelectorAll('.modal');
      if (!modals || !modals.length) return;

      // Kick off playback as part of the user click that opens the modal.
      // This preserves "user gesture" context (better chance of autoplay WITH sound).
      document.addEventListener('click', function (e) {
        var trigger = e.target && e.target.closest ? e.target.closest('[data-modal-trigger]') : null;
        if (trigger) {
          var targetId = trigger.getAttribute('data-modal-target');
          var modal = targetId ? document.getElementById(targetId) : null;
          setStickyHeaderHidden(true);
          // Prefer sound on user click; if a browser blocks it, switch back to mute=true.
          autoplayYouTubeInModal(modal, { mute: false });
          playHtml5VideosInModal(modal, { preferSound: true });
          return;
        }
      });

      // Catch already-open modals (rare, but safe).
      for (var i = 0; i < modals.length; i++) {
        handleModalMaybeChanged(modals[i]);
      }
      setStickyHeaderHidden(isAnyThemeModalOpen());

      var observer = new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var mutation = mutations[m];
          var target = mutation.target;
          if (target && target.classList && target.classList.contains('modal')) {
            handleModalMaybeChanged(target);
            // In case multiple modals exist, always decide based on global state.
            setStickyHeaderHidden(isAnyThemeModalOpen());
          }
        }
      });

      for (var j = 0; j < modals.length; j++) {
        observer.observe(modals[j], { attributes: true, attributeFilter: ['data-open', 'style'] });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initYouTubeModalAutoplay);
  } else {
    initYouTubeModalAutoplay();
  }
})();
